import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section } from './Shared';
import { Blossom, Daisy } from './FloralDecor';
import { reviews } from '../data/reviews';
import type { Review } from '../types/product';
const accents: Record<Review['accent'], string> = {
  rose: 'bg-rose-100 text-rose-800',
  violet: 'bg-violet-100 text-violet-800',
  amber: 'bg-amber-100 text-amber-800'
};
export function Reviews() {
  return <Section id="reviews" data-id="element-223" data-mp="2w9d69os62cmf">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10 overflow-hidden" data-id="element-224" data-mp="2w822hoyq14vb">
        <Daisy className="absolute left-[3%] top-12 h-14 w-14" petalClassName="text-amber-100" centerClassName="text-amber-400" data-id="element-225" data-mp="3093t5heko8lo" />
        <Blossom className="absolute bottom-10 right-[4%] h-16 w-16" petalClassName="text-pink-200" centerClassName="text-amber-300" data-id="element-226" data-mp="3a1t0q17052bq" />
      </div>

      <h2 className="mb-10 text-center text-2xl font-bold tracking-tight text-emerald-900 md:text-4xl" data-id="element-227" data-mp="3jz7hy30r1v53">
        What buyers are saying
      </h2>

      <ul className="mx-auto grid max-w-6xl gap-5 md:grid-cols-3" data-id="element-228" data-mp="2re8ld8k3sdms">
        {reviews.map(review => <li key={review.name} data-id="element-229" data-mp="2mbzr88vhv5j3">
            <figure className="flex h-full flex-col rounded-xl border border-stone-200 bg-white p-6 shadow-sm" data-id="element-230" data-mp="2hehq34npxuln">
              <div className="flex gap-0.5 text-amber-400" aria-label="Rated 5 out of 5" data-id="element-231" data-mp="2dd5yitlaazat">
                {Array.from({
              length: 5
            }, (_, index) => <StarIcon key={index} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-232" data-mp="3a2ndjz65pxp6" />)}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-stone-700 md:text-base" data-id="element-233" data-mp="356es641d989k">
                “{review.text}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-stone-200 pt-4" data-id="element-234" data-mp="2wb8rfjgydgdw">
                <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm font-semibold ${accents[review.accent]}`} aria-hidden="true" data-id="element-235" data-mp="3sv7po4xmzo6a">
                  {review.initials}
                </span>
                <span data-id="element-236" data-mp="1r3fo3i422cpe">
                  <span className="block text-sm font-semibold text-stone-900" data-id="element-237" data-mp="1r3peh6t0ilvm">{review.name}</span>
                  <span className="block text-xs text-stone-500" data-id="element-238" data-mp="1cfb1w45snj1v">
                    {review.role} · {review.location}
                  </span>
                </span>
              </figcaption>
            </figure>
          </li>)}
      </ul>
    </Section>;
}